// Vaanmathi
import { useEffect, useState } from 'react';

const Toast = ({ message, type, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(onClose, 300);
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  // Custom color configurations
  const getToastStyle = () => {
    const styles = {
      success: {
        backgroundColor: '#4CAF50', // Green
        icon: '✓',
        textColor: '#FFFFFF',
        closeButtonColor: 'rgba(255,255,255,0.8)'
      },
      error: {
        backgroundColor: '#F44336', // Red
        icon: '✕',
        textColor: '#FFFFFF',
        closeButtonColor: 'rgba(255,255,255,0.8)'
      },
      warning: {
        backgroundColor: '#FF9800', // Amber
        icon: '⚠',
        textColor: '#000000',
        closeButtonColor: 'rgba(0,0,0,0.7)'
      },
      info: {
        backgroundColor: '#2196F3', // Blue
        icon: 'ℹ',
        textColor: '#FFFFFF',
        closeButtonColor: 'rgba(255,255,255,0.8)'
      },
      default: {
        backgroundColor: '#673AB7', // Deep Purple
        icon: '●',
        textColor: '#FFFFFF',
        closeButtonColor: 'rgba(255,255,255,0.8)'
      }
    };

    return styles[type] || styles.default;
  };

  const toastStyle = getToastStyle();

  return (
    <div 
      className={`toast show ${isExiting ? 'fade-out' : 'fade-in'}`}
      style={{
        minWidth: '300px',
        maxWidth: '320px',
        transition: 'all 0.3s ease',
        marginBottom: '12px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        backgroundColor: toastStyle.backgroundColor,
        color: toastStyle.textColor,
      }}
    >
      <div className="d-flex justify-content-between align-items-center p-1">
        <div className="d-flex align-items-center">
<span 
  className="me-3" 
  style={{
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginLeft: '10px' // Add margin left here
  }}
>
  {toastStyle.icon}
</span>
          <div className="toast-body">
            {message}
          </div>
        </div>
       <button 
  type="button" 
  className="btn-close"
  style={{
    filter: `brightness(0) invert(${toastStyle.textColor === '#FFFFFF' ? 1 : 0})`,
    opacity: 0.8,
    marginRight: '10px' // Add margin right here
  }}
  onClick={() => {
    setIsExiting(true);
    setTimeout(onClose, 300);
  }}
  aria-label="Close"
/>
      </div>
    </div>
  );
};

export const Toaster = ({ toasts, removeToast }) => {
  return (
    <div 
      className="toast-container"
      style={{
        position: 'fixed',
        top: '24px',
        right: '24px',
        zIndex: 9999,
      }}
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};